import React from 'react';
import PropTypes from 'prop-types';
// eslint-disable-next-line lodash/import-scope -- directive added automatically by Shepherd migration
import get from 'lodash/get';

/**
 * Takes a months value and returns that as a number of years if it's an exact
 * number of years (e.g. 12 months, 24 months..), else returns number of months.
 */
const formatMonthsOutput = (months) => {
  if (months % 12 !== 0) {
    return `${months} months`;
  }

  // Using division instead of strict equals in case months is a string
  if (months / 12 === 1) {
    return '1 year';
  }

  return `${months / 12} years`;
};

const MonthsInYears = ({ data }) => {
  const months = Math.round(get(data, 'details.cd_deposit_term.value', 0) / 30);
  return <div className="product-value"> {formatMonthsOutput(months)} </div>;
};

MonthsInYears.propTypes = {
  data: PropTypes.shape({
    details: PropTypes.shape({
      cd_deposit_term: PropTypes.shape({
        value: PropTypes.number,
      }),
    }),
  }),
};

MonthsInYears.displayName = 'MonthsInYears';

export default MonthsInYears;
